import React, { useState, useEffect, useRef } from 'react'
import { useForm } from "react-hook-form";
import { Typography, Card, Box, Switch, Stack, Grid, Checkbox, Paper, Button, Hidden, TextField, IconButton, Snackbar, CardContent, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import DialogContent from '@mui/material/DialogContent';
import { Icon } from '@iconify/react';
import SaveIcon from '@mui/icons-material/Save';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import styles from '.././../../styles.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { addInvoiceSetting, addMenuSetting, editInvoiceSetting, editMenuSetting, getInvoiceSettingList, getMenuSettingList } from '../../../actions/actions';
import { dateConversionOnEntryPageWithTime } from '../../reusableComponent/dateConversionOnEntryPage';
import { BackBtn } from '../../reusableComponent/BackBtn';


const MenuSetting = (props) => {
    const { handleSubmit } = useForm();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const [successMessage, setSuccessMessage] = useState(null);

    
    const [showEWayBillNo, setShowEWayBillNo] = useState(false);
    const [productionRequired, setProductionRequired] = useState(false);

    const rows = useSelector(state => state.menuSetting.menuSetting)

    const fetchData = () => {
        dispatch(getMenuSettingList({ companyId: userInfo.companyId }))
    }
    useEffect(() => {
        fetchData()
    }, []);
   
    const handleChangeProductionRequired = (event) => {
        setProductionRequired(event.target.checked)
    };
   
    const handleChangeShowEWayBillNo = (event) => {
        setShowEWayBillNo(event.target.checked)
    };
    

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.menuSetting.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);

    useEffect(() => {
        if (rows.length > 0) {
            
            setShowEWayBillNo(rows[0].showEWayBillNo === 'true' ? true : false)
         
            setProductionRequired(rows[0].productionRequired === 'true' ? true : false)
         
        }
    }, [rows]);


    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const onSubmit = (event) => {
        let sending_data = {
            companyId: userInfo.companyId,
            id: rows.length > 0 ? rows[0].id : null,
           
            showEWayBillNo: showEWayBillNo,
       
            productionRequired: productionRequired,
     
            createdBy: rows.length > 0 ? rows[0].createdBy : userInfo.userId,
            createdAt: rows.length > 0 ? rows[0].createdAt : dateConversionOnEntryPageWithTime(new Date()),
            modifiedBy: rows.length > 0 ? userInfo.userId : null,
            modifiedAt: rows.length > 0 ? dateConversionOnEntryPageWithTime(new Date()) : '',
        }
        if (rows.length > 0) {
            dispatch(editMenuSetting(sending_data));
        } else {
            dispatch(addMenuSetting(sending_data));
        }
    }

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    const handleClick = () => {
        const value = props.value - 1;
        props.onValueReceived(value);
    };

    return (
        <>
         <Breadcrumb
                    routeSegments={[
                        { name: 'Settings', path: '/settings' },
                        { name: 'Create Menu Settings' },
                    ]}
                />  
        <Paper className={`${styles.list_container}`}>
            
            {/* <Box sx={{ display: 'flex', paddingLeft: '50px' }}>
                <Grid container spacing={0.2} sx={{ mt: 2, pb: 2 }}>
                    <Grid item md={12} xs={12}>
                        <Typography className={`${styles.page_title}`}>Create Invoice Fields Setting</Typography>
                    </Grid>
                </Grid>
            </Box> */}

            <Grid container spacing={1} sx={{ paddingLeft: '50px', mt: 2, }}>
                <Grid item xs={3}>
                    <Typography className={`${styles.erp_lable}`}> Create Header Menu Setting in regard to the Tabs that you may require in the Header of BillCube .
                        make uses for the That Modules.</Typography>
                </Grid>
                <Divider orientation="vertical" flexItem sx={{ borderRightWidth: 2, minHeight: 200, }} />
                <Grid item xs={8.8} style={{}}>
                    <Box sx={{ width: '100%' }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={1} sx={{pl:2}}>
                            <Grid item xs={6} >
                                    <Grid container spacing={1} sx={{}}>
                                        <Grid item xs={12} style={{ marginTop: '10px' }}>
                                            <Typography className={`${styles.erp_lable}`} >
                                                <u> <b>Top Header Settings </b></u>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography className={`${styles.erp_lable}`}>
                                                Production Required
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Typography className={`${styles.erp_lable}`}>No</Typography>
                                                <Switch
                                                    size="small"
                                                    onChange={(e) => (handleChangeProductionRequired(e))}
                                                    name='productionRequired'
                                                    value={productionRequired}
                                                    checked={productionRequired}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                                <Typography className={`${styles.erp_lable}`}>Yes</Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography className={`${styles.erp_lable}`}>
                                               Reports Required
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Typography className={`${styles.erp_lable}`}>No</Typography>
                                                <Switch
                                                    size="small"
                                                    onChange={(e) => (handleChangeShowEWayBillNo(e))}
                                                    name='showEWayBillNo'
                                                    value={showEWayBillNo}
                                                    checked={showEWayBillNo}
                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                />
                                                <Typography className={`${styles.erp_lable}`}>Yes</Typography>
                                            </Stack>
                                        </Grid>
                                       
                                    </Grid>
                                </Grid>
                                <Grid item xs={6} >
                                  
                                </Grid>
                           
                            </Grid>
                            <Box sx={{ marginTop: '12px', float: 'right', }}>
                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {rows.length > 0 ? 'Update' : 'Save'}
                                </Button>
                            </Box>
                        </form>
                    </Box >
                </Grid>
            </Grid>

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={1000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }

        </Paper>
        </>
    )
}
export default MenuSetting